<template>
  <div class="indexpage">
    <at-modal
      v-model="showMe"
      :showFooter="false"
      :showHead="false"
      :showClose="false"
      :styles="{
        maxWidth: '100vw',
        minWidth: '100vw',
        top: '0px !important',
        background: 'none',
      }"
    >
      <div id="indexpagemaindiv" class="maindiv">
        <img
          src="/static/lang/img/vyatsu.png"
          class="logo"
          style="left: 10px; top: 10px"
          @click="showMe = false"
        />
        <img
          src="/static/lang/img/650v.png"
          class="logo"
          style="right: 10px; top: 10px"
          @click="showMe = false"
        />
        <div
          style="
            width: 100%;
            height: calc(100vh - 155px);
            display: flex;
            align-items: center;
            justify-content: center;
            background-color: rgb(222 222 222 / 60%);
            flex-wrap: nowrap;
            flex-direction: column;
            cursor: pointer;
            backdrop-filter: blur(5px);
          "
          @click="showMe = false"
        >
          <img
            src="/static/lang/img/bird.png"
            style="
              width: 70%;
              max-width: 400px;
              filter: brightness(0.25) drop-shadow(2px 2px 2px #11111166);
            "
          />
          <p
            style="
              font-family: 'Izhitsa Cyrillic', sans-serif;
              font-size: 260% !important;
              color: rgb(66 56 56);
              font-weight: bolder;
              text-shadow: 2px 2px 2px #11111166;
              margin-left: 30px;
              margin-right: 30px;
              text-align: center;
              max-width: 550px;
            "
          >
            Сетевой электронный словарь вятских говоров
          </p>
        </div>
        <div
          style="background-color: white; padding: 16px; padding-bottom: 40px"
        >
          <p>
            Добро пожаловать! Здесь вы найдете подробную информацию о наиболее
            распространенных говорах Вятского края.
          </p>
          <p>
            Цель сайта – представить наиболее распространённые диалектные слова,
            отражающие особенности быта, культуры и духовных традиций вятской
            деревни, а также дать лексический материал для исследовательской
            лингвокраеведческой работы.
          </p>
          <p>
            Мы надеемся, что данный электронный ресурс, создаваемый к 650-летию
            Хлынова-Вятки-Кирова, послужит задаче сохранения и продвижения
            национальных традиций и культуры края.
          </p>
          <div class="row mainMenu">
            <div class="col-sm-4">
              <router-link
                to="about"
                style="
                  position: absolute;
                  bottom: 0;
                  left: 0;
                  right: 0;
                  color: red;
                "
              >
                О проекте
              </router-link>
            </div>
            <div class="col-sm-4">
              <router-link
                to="help"
                style="
                  position: absolute;
                  bottom: 0;
                  left: 0;
                  right: 0;
                  color: red;
                "
              >
                Инструкция
              </router-link>
            </div>
            <div class="col-sm-4">
              <router-link
                to="/"
                style="
                  position: absolute;
                  bottom: 0;
                  left: 0;
                  right: 0;
                  color: red;
                "
              >
                <span @click="focusToSearch">Начать работу</span>
              </router-link>
            </div>
          </div>
          <center>
            <img
              src="/static/lang/img/venzel.png"
              style="
                width: 70%;
                max-width: 400px;
                filter: brightness(0.25) drop-shadow(2px 2px 2px #11111166);
              "
            />
          </center>
          <!-- <p
            style="
              font-family: 'Izhitsa Cyrillic', sans-serif;
              font-size: 200% !important;
              color: red;
              font-weight: bolder;
              text-align: center;
            "
          >
            Пример заголовка
          </p> -->
          <p>Кто не изучил говоров родного языка, тот знает его наполовину</p>
          <p style="text-align: right">Шарль Нодье</p>
        </div>
        <div
          style="width: 100%; text-align: center; height: 100vh"
          @click="showMe = false"
        >
          &nbsp;
        </div>
        <div
          id="indexscrollflag"
          style="width: 100%; text-align: center; height: 0"
        >
          &nbsp;
        </div>
      </div>
    </at-modal>
  </div>
</template>

<script>
export default {
  data: () => ({
    showMe: true,
  }),
  watch: {
    showMe() {
      if (!this.showMe) this.$router.push({ path: "/" });
    },
  },
  methods: {
    focusToSearch() {
      setTimeout(() => {
        document.getElementById("simplesearch").focus();
      }, 100);
    },
    handleScroll() {
      if (document.getElementById("indexscrollflag")) {
        var bottompos =
          document.getElementById("indexpagemaindiv").getBoundingClientRect()
            .top + document.getElementById("indexpagemaindiv").clientHeight;
        var currentpos = document
          .getElementById("indexscrollflag")
          .getBoundingClientRect().top;
        if (currentpos - bottompos < 50) this.showMe = false;
      }
    },
  },
  mounted() {
    setTimeout(() => {
      document
        .getElementById("indexpagemaindiv")
        .addEventListener("scroll", this.handleScroll);
    }, 100);
  },
};
</script>

<style scoped>
p {
  font-family: "Century Gothic", sans-serif;
  text-align: justify;
  font-size: 154% !important;
  margin: 14px;
  max-width: 700px;
  margin-left: auto;
  margin-right: auto;
}

p:first-child:first-letter {
  font-family: "Izhitsa Cyrillic", sans-serif;
  color: rgb(255, 0, 0);
  font-size: 60px;
  line-height: 60px;
  vertical-align: top;
  display: inline-block;
  float: left;
  margin: 0 10px 0 0;
}

.maindiv {
  overflow-y: auto;
  overflow-x: hidden;
  height: calc(100vh - 58px);
  margin: -16px;
  position: relative;
  margin-top: 40px;
}

.mainMenu {
  font-family: "Izhitsa Cyrillic", sans-serif;
  height: 50px;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
  color: red;
  font-size: 180%;
  margin-bottom: 32px;
}

.mainMenu > div {
  text-align: center;
  font-weight: bold;
  position: relative;
}

.logo {
  min-height: 90px;
  max-height: 200px;
  height: 20%;
  position: absolute;
  cursor: pointer;
  z-index: 1;
}

@media (max-width: 576px) {
  .mainMenu {
    height: 300px;
    margin-bottom: 60px;
  }
  .logo {
    height: 15%;
  }
}
</style>

